import React, {useState} from 'react';
import warningIconBlack from '../../assets/svgs/warning-black.svg'
import warningIconYellow from '../../assets/svgs/warning-yellow.svg'
import crossIconBlack from '../../assets/svgs/cross-black.svg'
import crossIconWhite from '../../assets/svgs/cross-white.svg'
import { formatUnixMsTimeAsLocalBrowserTime, validateIfDateToday } from '../common/date_time'

const Notification = (props) => {

  const [ showAddittionalInfo, toggleShowAddittionalInfo ] = useState(false)

  const toggleShowNotification = (id) => {
    props.setSystemDowntimeNotificationSeen(id)
  }

  if ( !props?.downTimeNotification?.message || 
      (props?.downTimeNotification?.seen && validateIfDateToday(props?.downTimeNotification?.seenDate))) {
    return null
  }

  const eventStart = props?.downTimeNotification?.eventStart
    ? formatUnixMsTimeAsLocalBrowserTime(props.downTimeNotification.eventStart)
    : null;
  const eventEnd = props?.downTimeNotification?.eventEnd
    ? formatUnixMsTimeAsLocalBrowserTime(props.downTimeNotification.eventEnd)
    : null;

  return (
    <>
    <div id="notification" className="notification">
      <img className="notificationImg" src={warningIconBlack} alt="warning-icon" />
      <div className="notificationText">
        {props?.downTimeNotification?.message} 
        {eventStart && eventEnd && <span> ({eventStart} - {eventEnd})</span>}
        {props.downTimeNotification?.additionalInfo && props.strings?.Common?.readMore
          && <span onClick={()=>{toggleShowAddittionalInfo(!showAddittionalInfo)}} className="notificationReadMore">{props.strings.Common.readMore}</span>}
      </div>
      <div className="notificationCrossWrapper">
        <img onClick={() => toggleShowNotification(props.downTimeNotification?.id)} className="notificationCross" src={crossIconBlack} alt="cross-icon" />
      </div>
    </div>
    {props.downTimeNotification?.additionalInfo && showAddittionalInfo &&
      <div className="notificationOverlayWrapper">
        <div className="notificationOverlayContentWrapper">
          <img onClick={()=>{toggleShowAddittionalInfo(!showAddittionalInfo)}} className="notificationOverlayCross" src={crossIconWhite} alt="cross-icon-white" />
          <div className="notificationOverlay">
            <div className="notificationOverlayIconTitle">
              <img className="notificationIcon" src={warningIconYellow} alt="warning-icon" />
              <div className="notificationTitle">{props.downTimeNotification?.message}</div>
            </div>
            {eventStart && eventEnd && <div className="notificationDate">{eventStart} - {eventEnd}</div>}
            <div className="notificationAdditionalInfo">{props.downTimeNotification?.additionalInfo}</div>
          </div>
        </div>
      </div>
    }
    </>
  );



};

export default Notification;
